module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00300.e6bf49c9.jpg";